import { render, staticRenderFns } from "./MostClickedPhrases.vue?vue&type=template&id=271210a6"
import script from "./MostClickedPhrases.vue?vue&type=script&lang=ts"
export * from "./MostClickedPhrases.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports